import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Requirements", -1)
const _hoisted_2 = { class: "dashboard__section switch-group--vertical" }
const _hoisted_3 = { class: "switch-group__item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Discord Linked ")
const _hoisted_5 = { class: "switch-group__item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Discord Guild Member ")
const _hoisted_7 = { class: "switch-group__item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Discord Guild Booster ")
const _hoisted_9 = { class: "switch-group__item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Steam Linked ")
const _hoisted_11 = { class: "switch-group__item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Steam Group Member ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "Action Details", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" When to run this action ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: -1
}, "Select when to run this action", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "The first time a player meets the requirements", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Every time a player meets the requirements", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Every time a player does not meet the requirements", -1)
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" What to do when this action is run ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, "Select an action type", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "dashboard__section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createElementBlock("form", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "no-margin-top",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.action.requirements.discord) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.action.requirements.discord]
        ])
      ]),
      _createElementVNode("label", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "no-margin-top",
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.action.requirements.discordGuildMember) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.action.requirements.discordGuildMember]
        ])
      ]),
      _createElementVNode("label", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "no-margin-top",
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.action.requirements.discordGuildBooster) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.action.requirements.discordGuildBooster]
        ])
      ]),
      _createElementVNode("label", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          class: "no-margin-top",
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.action.requirements.steam) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.action.requirements.steam]
        ])
      ]),
      _createElementVNode("label", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          class: "no-margin-top",
          type: "checkbox",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.action.requirements.steamGroupMember) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.action.requirements.steamGroupMember]
        ])
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _hoisted_14,
        _createVNode(_component_base_input, {
          class: "form__input",
          placeholder: "A name to identify this action, e.g. add linked role",
          error: _ctx.errors.nameError,
          modelValue: _ctx.action.name,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.action.name) = $event))
        }, null, 8, ["error", "modelValue"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _hoisted_15,
        _withDirectives(_createElementVNode("select", {
          class: "form__input",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.action.whenToRun) = $event))
        }, _hoisted_20, 512), [
          [_vModelSelect, _ctx.action.whenToRun]
        ])
      ]),
      _withDirectives(_createElementVNode("p", { class: "form__error" }, _toDisplayString(_ctx.errors.whenToRunError), 513), [
        [_vShow, _ctx.errors.whenToRunError]
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _hoisted_21,
        _withDirectives(_createElementVNode("select", {
          class: "form__input",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.action.definitionName) = $event))
        }, [
          _hoisted_22,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionDefinitions, (definition, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: definition.name
            }, _toDisplayString(definition.displayName), 9, _hoisted_23))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.action.definitionName]
        ])
      ]),
      _withDirectives(_createElementVNode("p", { class: "form__error" }, _toDisplayString(_ctx.errors.definitionNameError), 513), [
        [_vShow, _ctx.errors.definitionNameError]
      ])
    ]),
    _withDirectives(_createElementVNode("h4", null, "Action Arguments", 512), [
      [_vShow, _ctx.definition && _ctx.definition.parameters.length !== 0]
    ]),
    (_ctx.definition && _ctx.definition.parameters.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definition.parameters, (arg, index) => {
            return (_openBlock(), _createElementBlock("label", {
              class: _normalizeClass({ 'form__label': index !== 0 }),
              key: index
            }, [
              _createTextVNode(_toDisplayString(arg.displayName) + " ", 1),
              _createVNode(_component_base_input, {
                class: "form__input",
                error: _ctx.errors.argumentErrors[arg.key],
                modelValue: _ctx.action.arguments[arg.key],
                "onUpdate:modelValue": ($event: any) => ((_ctx.action.arguments[arg.key]) = $event)
              }, null, 8, ["error", "modelValue", "onUpdate:modelValue"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}